<template>
	<HeroDiagonal v-bind="$props">
		<template #head>
			<div class="flex flex-col gap-4">
				<span
					v-if="pageTitlePrefix"
					class="text-white drop-shadow-lg font-display text-title-size-lg lg:text-title-size-xl font-bold uppercase italic text-center"
				>
					{{ pageTitlePrefix }}
				</span>
				<h1
					class="text-white drop-shadow-lg font-display text-title-size-3xl sm:text-title-size-4xl lg:text-display-size-lg font-black italic uppercase text-center"
				>
					{{ pageTitle }}
				</h1>
				<span
					v-if="pageTitleSuffix"
					class="text-white drop-shadow-lg font-display text-title-size-lg lg:text-paragraph-size-xl text-center"
				>
					{{ pageTitleSuffix }}
				</span>
			</div>
		</template>
		<slot />
	</HeroDiagonal>
</template>

<script lang="ts" setup>
import HeroDiagonal from '#base/app/components/template/HeroDiagonal.vue';
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { VideoType } from '#base/core/types/VideoType';
import type { VideoColorEnum } from '#base/core/enums/VideoColorEnum';

defineProps<{
	backgroundVideo?: VideoType;
	pageTitle: string;
	pageTitlePrefix?: string;
	pageTitleSuffix?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	videoColor?: VideoColorEnum;
}>();
</script>
